var _defs, _line, _path, _path2, _path3, _path4, _path5, _path6, _g, _path7, _path8, _g2, _path9, _g3, _path10, _g4, _path11, _path12, _g5, _path13, _path14, _path15, _path16, _path17, _rect, _path18, _path19, _g6, _g7, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _g8, _path58, _path59, _g9, _path60, _g10, _path61, _path62, _g11, _path63, _g12, _path64, _g13, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _g14, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPeople(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 257.774,
    height: 257.117,
    viewBox: "0 0 257.774 257.117",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_98",
    "data-name": "Rectangle 98",
    width: 252.885,
    height: 256.17,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_82",
    "data-name": "Rectangle 82",
    width: 6.584,
    height: 13.249,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_83",
    "data-name": "Rectangle 83",
    width: 21.954,
    height: 6.322,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_84",
    "data-name": "Rectangle 84",
    width: 6.828,
    height: 6.828,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_85",
    "data-name": "Rectangle 85",
    width: 5.101,
    height: 5.904,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_86",
    "data-name": "Rectangle 86",
    width: 5.101,
    height: 5.905,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_88",
    "data-name": "Rectangle 88",
    width: 7.809,
    height: 56.031,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_89",
    "data-name": "Rectangle 89",
    width: 7.81,
    height: 56.031,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_90",
    "data-name": "Rectangle 90",
    width: 6.358,
    height: 11.146,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_92",
    "data-name": "Rectangle 92",
    width: 5.265,
    height: 6.093,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_93",
    "data-name": "Rectangle 93",
    width: 5.265,
    height: 6.094,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_94",
    "data-name": "Rectangle 94",
    width: 6.146,
    height: 7.063,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_95",
    "data-name": "Rectangle 95",
    width: 20.284,
    height: 15.095,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_96",
    "data-name": "Rectangle 96",
    width: 51.803,
    height: 79.333,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_340",
    "data-name": "Group 340",
    transform: "translate(-9.5 -272)"
  }, _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "Line_10",
    "data-name": "Line 10",
    x1: 255.774,
    transform: "translate(10.5 528.117)",
    fill: "none",
    stroke: "#2c3344",
    strokeLinecap: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_252",
    "data-name": "Group 252",
    transform: "translate(11.099 272)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_251",
    "data-name": "Group 251",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_250",
    "data-name": "Group 250"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_249",
    "data-name": "Group 249",
    clipPath: "url(#clip-path)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_322",
    "data-name": "Path 322",
    d: "M52.47,298.359a18.954,18.954,0,0,1-3.925-6.846,40.5,40.5,0,0,1-1.725-7.649c-.356-2.531-.546-5.02-.8-7.4-.076-.595-.123-1.191-.182-1.785L45.62,272.9c-.148-1.185-.265-2.374-.458-3.554-.638-4.734-1.444-9.446-2.377-14.206q-.7-3.572-1.46-7.211c-.5-2.437-1.046-4.888-1.469-7.474a43.2,43.2,0,0,1,8.431,12.952,53.538,53.538,0,0,1,2.583,7.328c.362,1.248.622,2.519.916,3.784.233,1.277.467,2.555.642,3.842s.291,2.581.394,3.876c.067,1.3.142,2.594.126,3.893,0,2.6-.183,5.105-.384,7.558-.4,4.914-.856,9.515-.1,14.669",
    transform: "translate(-10.62 -64.075)",
    fill: "#ffd5ab"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_323",
    "data-name": "Path 323",
    d: "M94.316,20.585v6.349a18.233,18.233,0,0,0-4.832-2.325A40.821,40.821,0,0,0,76.112,22.6,40.818,40.818,0,0,0,62.74,24.609a18.233,18.233,0,0,0-4.832,2.325V20.585a46.3,46.3,0,0,1,36.408,0",
    transform: "translate(-15.431 -4.495)",
    fill: "#2c3344"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_324",
    "data-name": "Path 324",
    d: "M94.316,15.932v3.413a46.3,46.3,0,0,0-36.408,0V15.932a46.3,46.3,0,0,1,36.408,0",
    transform: "translate(-15.431 -3.255)",
    fill: "#ed4f4f"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_325",
    "data-name": "Path 325",
    d: "M94.316,8.289v5.443a46.3,46.3,0,0,0-36.408,0V8.289s5.625-4.326,18.2-4.326,18.2,4.326,18.2,4.326",
    transform: "translate(-15.431 -1.056)",
    fill: "#2c3344"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_326",
    "data-name": "Path 326",
    d: "M90.287,47.417s-.351,6.517-4.087,11.321a12.744,12.744,0,0,1-10.605,5.028,12.736,12.736,0,0,1-10.24-4.579C61.274,54.349,60.9,47.417,60.9,47.417c-2.83-.344-5.928-5.857-4.635-9.032a2.864,2.864,0,0,1,1.328-1.594,3.206,3.206,0,0,1,2.851.393l1.826-10.352-.049-.14a40.8,40.8,0,0,1,13.372-2.009,40.794,40.794,0,0,1,13.372,2.009l-.049.14,1.826,10.352a3.207,3.207,0,0,1,2.852-.393,2.866,2.866,0,0,1,1.327,1.594c1.292,3.175-1.805,8.688-4.635,9.032",
    transform: "translate(-14.913 -6.577)",
    fill: "#ff9a55"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_327",
    "data-name": "Path 327",
    d: "M105.769,29.746l-.2,7.775a3.206,3.206,0,0,0-2.851.393l-1.826-10.352.049-.14a18.2,18.2,0,0,1,4.832,2.325",
    transform: "translate(-26.884 -7.307)",
    fill: "#21232b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_209",
    "data-name": "Group 209",
    transform: "translate(56.601 29.237)",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_208",
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_207",
    "data-name": "Group 207",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_328",
    "data-name": "Path 328",
    d: "M82.043,39.858S83.9,52.921,83.735,52.935c-3.68.456-6.573.035-6.573-1.686s4.881-11.392,4.881-11.392",
    transform: "translate(-77.162 -39.858)",
    fill: "#21232b"
  }))))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_329",
    "data-name": "Path 329",
    d: "M90.04,76.468a66.407,66.407,0,0,1-11.2.962q-1.718.01-3.582-.084c-.717-.035-1.447-.078-2.192-.141-1.6-.126-3.266-.323-4.979-.59l.5-5.057a12.734,12.734,0,0,0,10.24,4.579,12.746,12.746,0,0,0,10.6-5.028Z",
    transform: "translate(-18.143 -18.949)",
    fill: "#ff9a55"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_330",
    "data-name": "Path 330",
    d: "M62.74,27.421l.049.14L60.963,37.913a3.207,3.207,0,0,0-2.852-.393l-.2-7.775a18.233,18.233,0,0,1,4.832-2.325",
    transform: "translate(-15.431 -7.307)",
    fill: "#21232b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_212",
    "data-name": "Group 212",
    transform: "translate(49.943 52.161)",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_211",
    "data-name": "Group 211"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_210",
    "data-name": "Group 210",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_331",
    "data-name": "Path 331",
    d: "M90.04,76.468a66.407,66.407,0,0,1-11.2.962q-1.718.01-3.582-.084c-.717-.035-1.447-.078-2.192-.141-1.6-.126-3.266-.323-4.979-.59l.5-5.057a12.734,12.734,0,0,0,10.24,4.579,12.746,12.746,0,0,0,10.6-5.028Z",
    transform: "translate(-68.085 -71.11)",
    fill: "#21232b"
  }))))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_332",
    "data-name": "Path 332",
    d: "M88.059,61.049a6.133,6.133,0,0,1-6.894,3.258c-.357-.1-.553.445-.194.545A6.726,6.726,0,0,0,88.6,61.244c.169-.331-.378-.522-.544-.194",
    transform: "translate(-21.525 -16.223)",
    fill: "#21232b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_215",
    "data-name": "Group 215",
    transform: "translate(65.817 38.103)",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_214",
    "data-name": "Group 214"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_213",
    "data-name": "Group 213",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_333",
    "data-name": "Path 333",
    d: "M89.727,55.359a3.414,3.414,0,1,0,3.414-3.414,3.414,3.414,0,0,0-3.414,3.414",
    transform: "translate(-89.727 -51.945)",
    fill: "#21232b"
  }))))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_334",
    "data-name": "Path 334",
    d: "M72.9,34.1a12.2,12.2,0,0,0-4.724,1.422c-1.725.939-.187,3.574,1.54,2.635A8.376,8.376,0,0,1,72.9,37.149a1.569,1.569,0,0,0,1.526-1.526A1.536,1.536,0,0,0,72.9,34.1",
    transform: "translate(-17.965 -9.084)",
    fill: "#21232b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_218",
    "data-name": "Group 218",
    transform: "translate(51.086 28.748)",
    opacity: 0.3,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_217",
    "data-name": "Group 217"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_216",
    "data-name": "Group 216",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_335",
    "data-name": "Path 335",
    d: "M74.744,42.143a2.578,2.578,0,1,1-2.55-2.952,2.774,2.774,0,0,1,2.55,2.952",
    transform: "translate(-69.643 -39.191)",
    fill: "#21232b"
  }))))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_336",
    "data-name": "Path 336",
    d: "M74.318,43.7a1.912,1.912,0,1,1-1.882-2.251A2.091,2.091,0,0,1,74.318,43.7",
    transform: "translate(-18.801 -11.045)",
    fill: "#21232b"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_337",
    "data-name": "Path 337",
    d: "M89.495,33.768a12.2,12.2,0,0,1,4.724,1.422c1.725.939.187,3.574-1.54,2.635a8.377,8.377,0,0,0-3.184-1.006,1.569,1.569,0,0,1-1.526-1.526,1.536,1.536,0,0,1,1.526-1.526",
    transform: "translate(-23.441 -8.997)",
    fill: "#21232b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_221",
    "data-name": "Group 221",
    transform: "translate(64.8 28.506)",
    opacity: 0.3,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_220",
    "data-name": "Group 220"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_219",
    "data-name": "Group 219",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_338",
    "data-name": "Path 338",
    d: "M88.34,41.814a2.578,2.578,0,1,0,2.55-2.952,2.773,2.773,0,0,0-2.55,2.952",
    transform: "translate(-88.34 -38.862)",
    fill: "#21232b"
  }))))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_339",
    "data-name": "Path 339",
    d: "M89.251,43.373a1.912,1.912,0,1,0,1.882-2.251,2.091,2.091,0,0,0-1.882,2.251",
    transform: "translate(-23.783 -10.958)",
    fill: "#21232b"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_340",
    "data-name": "Path 340",
    d: "M100.388,334.172H71.262c-1.089-4.116-5.689-19.349-8.329-28.03-1.116-3.673-1.882-6.173-1.882-6.173l-2.465,7.775-8.392,26.428H21.707l1.1-13.231,2.339-28.22a175.424,175.424,0,0,0,26.456,3.61c2.416.154,4.951.266,7.578.323a183.742,183.742,0,0,0,37.23-2.859Z",
    transform: "translate(-5.784 -78.002)",
    fill: "#2c3344"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_341",
    "data-name": "Path 341",
    d: "M81.866,281.375a2.124,2.124,0,1,1-2.025-2.217,2.124,2.124,0,0,1,2.025,2.217",
    transform: "translate(-20.684 -74.387)",
    fill: "#ffa840"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_342",
    "data-name": "Path 342",
    d: "M140.432,92.412l-.976,3.666-.147.555-20.43-6.307,1.285-3.35.049-.126Z",
    transform: "translate(-31.678 -23.143)",
    fill: "#ffb048"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_343",
    "data-name": "Path 343",
    d: "M.317,150.644C-2.27,135.5,11.61,98.678,19.069,92.132l.435,1.623,20.438-6.307L38.6,83.972c4.643-1.279,8.3-2.121,8.3-2.121l.394-4c.892.183,1.777.337,2.647.478,1.714.267,3.379.464,4.98.59l2.191.141q1.864.095,3.582.084a66.486,66.486,0,0,0,11.2-.962c1.974-.344,3.083-.654,3.083-.654L76.9,81.781s5.3.976,11.581,2.71L87.2,87.841l20.43,6.307.147-.555a4.376,4.376,0,0,1,.365.555c7.157,12.642,10.346,62.415,10.542,71.068s-22.65,16.4-22.65,16.4v53.756q-2.729.59-5.415,1.081a183.76,183.76,0,0,1-37.23,2.859,182.683,182.683,0,0,1-34.034-3.933c-2.767-.611-4.277-1.046-4.277-1.046l7.937-103.739S20.98,161.545,20.98,171.88",
    transform: "translate(0 -20.658)",
    fill: "#ed4f4f"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_87",
    "data-name": "Rectangle 87",
    width: 20.114,
    height: 5.077,
    transform: "translate(69.32 94.09)",
    fill: "#ffb048"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_344",
    "data-name": "Path 344",
    d: "M45.277,86.314l1.342,3.476L26.181,96.1l-.436-1.622-.688-2.6,19.4-5.338Z",
    transform: "translate(-6.677 -23)",
    fill: "#ffb048"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_345",
    "data-name": "Path 345",
    d: "M73.756,79.561,70.034,239.816c-2.627-.056-5.163-.169-7.578-.323l9.08-159.771.029-.3c.745.063,1.474.1,2.191.14",
    transform: "translate(-16.643 -21.163)",
    fill: "#ffb048"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_224",
    "data-name": "Group 224",
    transform: "translate(92.653 104.926)",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_223",
    "data-name": "Group 223"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_222",
    "data-name": "Group 222",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_346",
    "data-name": "Path 346",
    d: "M129.694,199.074l-3.383-56.031,7.81,29.479-2.485,7.743Z",
    transform: "translate(-126.311 -143.043)",
    fill: "#2c3344"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_227",
    "data-name": "Group 227",
    transform: "translate(15.02 104.926)",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_226",
    "data-name": "Group 226"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_225",
    "data-name": "Group 225",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_347",
    "data-name": "Path 347",
    d: "M24.9,199.074l3.383-56.031-7.81,29.479,2.485,7.743Z",
    transform: "translate(-20.477 -143.043)",
    fill: "#2c3344"
  }))))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_348",
    "data-name": "Path 348",
    d: "M138.321,100.959a38.953,38.953,0,0,0-12.2,21.97,37.886,37.886,0,0,0-.6,7.216.352.352,0,0,0,.7,0,38.327,38.327,0,0,1,7.8-23.506,36.977,36.977,0,0,1,4.79-5.183c.337-.3-.161-.8-.5-.5",
    transform: "translate(-33.446 -26.878)",
    fill: "#21232b"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_349",
    "data-name": "Path 349",
    d: "M33.669,116.419q-1.632,13.364-3.264,26.727-.462,3.787-.925,7.574c-.054.447.648.444.7,0l3.263-26.727q.463-3.787.925-7.574c.055-.447-.648-.444-.7,0",
    transform: "translate(-7.855 -30.933)",
    fill: "#21232b"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_350",
    "data-name": "Path 350",
    d: "M84.557,222.3a2.124,2.124,0,1,1-2.025-2.217,2.124,2.124,0,0,1,2.025,2.217",
    transform: "translate(-21.401 -58.645)",
    fill: "#ffa840"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_351",
    "data-name": "Path 351",
    d: "M83.244,251.1a2.123,2.123,0,1,1-2.025-2.217,2.123,2.123,0,0,1,2.025,2.217",
    transform: "translate(-21.051 -66.32)",
    fill: "#ffa840"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_352",
    "data-name": "Path 352",
    d: "M88.876,133.546a2.123,2.123,0,1,1-2.025-2.217,2.123,2.123,0,0,1,2.025,2.217",
    transform: "translate(-22.552 -34.994)",
    fill: "#ffa840"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_353",
    "data-name": "Path 353",
    d: "M87.564,162.348a2.123,2.123,0,1,1-2.025-2.217,2.123,2.123,0,0,1,2.025,2.217",
    transform: "translate(-22.202 -42.669)",
    fill: "#ffa840"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_354",
    "data-name": "Path 354",
    d: "M86.185,192.62a2.123,2.123,0,1,1-2.025-2.217,2.123,2.123,0,0,1,2.025,2.217",
    transform: "translate(-21.835 -50.736)",
    fill: "#ffa840"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_355",
    "data-name": "Path 355",
    d: "M89.255,103.906a2.123,2.123,0,1,1-2.025-2.217,2.123,2.123,0,0,1,2.025,2.217",
    transform: "translate(-22.653 -27.096)",
    fill: "#ffa840"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Path_356",
    "data-name": "Path 356",
    d: "M209,59.273a344.075,344.075,0,0,1-3.7,37,145.066,145.066,0,0,1-10.3,35.526,133.076,133.076,0,0,1-46.644,56.025l1.669,2.413a135.267,135.267,0,0,0,46.322-57.857,146.22,146.22,0,0,0,9.672-35.993A344.206,344.206,0,0,0,209,59.273",
    transform: "translate(-39.534 -15.795)",
    fill: "#ffd5ab"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Path_357",
    "data-name": "Path 357",
    d: "M230.195,47.167a38.076,38.076,0,0,0,4.018-11.67,54.8,54.8,0,0,0-1.065-24.228A37.79,37.79,0,0,0,228.1,0a90.67,90.67,0,0,0-.667,12.062c0,3.9.1,7.745.275,11.585s.418,7.674.762,11.563a92.427,92.427,0,0,0,1.722,11.956",
    transform: "translate(-60.605 0)",
    fill: "#ffd5ab"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Path_358",
    "data-name": "Path 358",
    d: "M219.5,75.622a18.952,18.952,0,0,0-.935-7.836,40.547,40.547,0,0,0-3.179-7.167c-1.225-2.244-2.557-4.354-3.767-6.415-.294-.523-.613-1.029-.919-1.542l-.892-1.557c-.588-1.039-1.2-2.063-1.752-3.125-2.313-4.18-4.477-8.441-6.57-12.819q-1.57-3.283-3.13-6.658c-1.052-2.253-2.077-4.546-3.279-6.874a43.193,43.193,0,0,0,.96,15.425,53.53,53.53,0,0,0,2.3,7.422c.454,1.217,1,2.392,1.523,3.583.575,1.163,1.149,2.329,1.777,3.467s1.307,2.245,2,3.346c.72,1.081,1.434,2.165,2.222,3.2,1.551,2.091,3.193,3.987,4.816,5.836,3.25,3.707,6.364,7.126,8.829,11.715",
    transform: "translate(-51.897 -5.763)",
    fill: "#ffd5ab"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Path_359",
    "data-name": "Path 359",
    d: "M228.451,75.622c2.465-4.59,5.579-8.008,8.829-11.715,1.623-1.848,3.265-3.745,4.816-5.836.788-1.034,1.5-2.118,2.222-3.2.69-1.1,1.367-2.21,2-3.346s1.2-2.3,1.777-3.467c.519-1.191,1.069-2.366,1.523-3.583a53.536,53.536,0,0,0,2.3-7.422,43.21,43.21,0,0,0,.961-15.425c-1.2,2.327-2.228,4.621-3.28,6.874s-2.083,4.469-3.13,6.658c-2.092,4.378-4.257,8.64-6.57,12.819-.549,1.061-1.164,2.085-1.752,3.125l-.892,1.557c-.307.513-.625,1.019-.919,1.542-1.21,2.061-2.541,4.171-3.767,6.415a40.55,40.55,0,0,0-3.179,7.167,18.952,18.952,0,0,0-.934,7.836",
    transform: "translate(-60.85 -5.763)",
    fill: "#ffd5ab"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Path_360",
    "data-name": "Path 360",
    d: "M214.435,114.548a18.965,18.965,0,0,0,.136-7.89,40.6,40.6,0,0,0-2.179-7.532c-.91-2.389-1.944-4.66-2.864-6.866-.22-.558-.467-1.1-.7-1.653l-.672-1.663c-.442-1.11-.914-2.208-1.314-3.334-1.725-4.455-3.292-8.97-4.772-13.59q-1.111-3.466-2.2-7.021c-.738-2.375-1.442-4.786-2.319-7.255a43.193,43.193,0,0,0-1.137,15.413,53.586,53.586,0,0,0,1.273,7.665c.285,1.267.67,2.506,1.023,3.756.412,1.231.823,2.463,1.291,3.675s.99,2.4,1.525,3.585c.567,1.169,1.127,2.34,1.768,3.471,1.254,2.282,2.623,4.383,3.982,6.435,2.718,4.113,5.341,7.922,7.161,12.8",
    transform: "translate(-52.279 -15.387)",
    fill: "#ffd5ab"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Path_361",
    "data-name": "Path 361",
    d: "M221.062,116.951c3.063-4.213,6.613-7.179,10.334-10.412,1.859-1.612,3.742-3.268,5.562-5.13.921-.917,1.774-1.895,2.635-2.869.833-1,1.653-2,2.431-3.044s1.5-2.119,2.23-3.194c.676-1.11,1.38-2.2,1.994-3.344a53.61,53.61,0,0,0,3.283-7.043,43.2,43.2,0,0,0,3.041-15.153c-1.507,2.144-2.832,4.277-4.18,6.367s-2.669,4.146-4,6.173c-2.666,4.053-5.388,7.983-8.245,11.811-.687.977-1.436,1.909-2.16,2.859l-1.094,1.422c-.373.467-.758.925-1.119,1.4-1.478,1.878-3.083,3.789-4.6,5.846a40.539,40.539,0,0,0-4.12,6.671,18.951,18.951,0,0,0-1.987,7.637",
    transform: "translate(-58.907 -17.79)",
    fill: "#ffd5ab"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Path_362",
    "data-name": "Path 362",
    d: "M225.338,53.064a10.674,10.674,0,0,0-.208-4.857,22.743,22.743,0,0,0-1.72-4.464c-1.427-2.779-2.84-5.111-4.168-7.615-1.347-2.473-2.655-4.968-3.982-7.528-1.358-2.559-2.644-5.186-4.336-7.934a22.68,22.68,0,0,0-.032,9.421,30.44,30.44,0,0,0,3.2,8.846,31.813,31.813,0,0,0,2.566,3.965,42.864,42.864,0,0,0,2.966,3.452,48.782,48.782,0,0,1,5.717,6.715",
    transform: "translate(-56.069 -5.507)",
    fill: "#ffd5ab"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Path_363",
    "data-name": "Path 363",
    d: "M230.7,53.129a48.792,48.792,0,0,1,5.8-6.644,42.939,42.939,0,0,0,3.009-3.415,31.839,31.839,0,0,0,2.614-3.932,30.437,30.437,0,0,0,3.307-8.806,22.694,22.694,0,0,0,.084-9.421c-1.725,2.727-3.044,5.339-4.433,7.88-1.359,2.545-2.7,5.022-4.075,7.479-1.359,2.487-2.8,4.8-4.261,7.563a22.743,22.743,0,0,0-1.776,4.443,10.683,10.683,0,0,0-.268,4.854",
    transform: "translate(-61.429 -5.572)",
    fill: "#ffd5ab"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Path_364",
    "data-name": "Path 364",
    d: "M204.849,144.969a18.962,18.962,0,0,0,.877-7.842,40.6,40.6,0,0,0-1.46-7.7c-.681-2.464-1.5-4.822-2.205-7.1-.166-.576-.362-1.141-.544-1.711l-.513-1.719c-.335-1.147-.7-2.284-.994-3.442-1.3-4.6-2.434-9.24-3.473-13.98q-.78-3.554-1.529-7.2c-.511-2.434-.985-4.9-1.625-7.441a43.2,43.2,0,0,0-2.582,15.238,53.459,53.459,0,0,0,.546,7.75c.164,1.289.431,2.559.665,3.836.295,1.264.588,2.53.939,3.781s.761,2.484,1.181,3.712c.455,1.217.9,2.436,1.434,3.622,1.033,2.39,2.2,4.61,3.358,6.781,2.318,4.351,4.571,8.389,5.924,13.42",
    transform: "translate(-50.843 -23.137)",
    fill: "#ffd5ab"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Path_365",
    "data-name": "Path 365",
    d: "M209.953,149.016c3.446-3.907,7.259-6.525,11.268-9.394,2-1.429,4.033-2.9,6.021-4.583,1-.827,1.945-1.72,2.893-2.608.922-.914,1.835-1.84,2.707-2.8s1.7-1.968,2.52-2.97c.777-1.042,1.581-2.06,2.3-3.142a53.529,53.529,0,0,0,3.931-6.7,43.2,43.2,0,0,0,4.454-14.8c-1.7,1.992-3.222,3.991-4.761,5.945s-3.047,3.877-4.565,5.769c-3.035,3.784-6.115,7.44-9.319,10.982-.777.908-1.61,1.765-2.42,2.643l-1.223,1.313c-.416.429-.841.849-1.247,1.292-1.648,1.73-3.426,3.481-5.13,5.386a40.533,40.533,0,0,0-4.73,6.253,18.951,18.951,0,0,0-2.7,7.416",
    transform: "translate(-55.946 -27.184)",
    fill: "#ffd5ab"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Path_366",
    "data-name": "Path 366",
    d: "M184.574,179.411a18.955,18.955,0,0,0,1.931-7.651,40.547,40.547,0,0,0-.4-7.83c-.341-2.534-.83-4.98-1.222-7.338-.087-.593-.2-1.18-.307-1.769l-.275-1.773c-.178-1.182-.386-2.358-.519-3.546-.664-4.731-1.16-9.485-1.547-14.321-.194-2.418-.377-4.86-.54-7.338s-.312-4.988-.6-7.592A43.172,43.172,0,0,0,176.467,135a53.5,53.5,0,0,0-.509,7.753c-.012,1.3.081,2.593.139,3.891.121,1.292.24,2.586.419,3.873s.417,2.564.667,3.839c.286,1.268.565,2.535.93,3.782.7,2.509,1.554,4.866,2.409,7.173,1.708,4.625,3.393,8.931,4.052,14.1",
    transform: "translate(-46.887 -32.044)",
    fill: "#ffd5ab"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Path_367",
    "data-name": "Path 367",
    d: "M187.7,185.76c3.943-3.4,8.075-5.482,12.436-7.781,2.178-1.145,4.389-2.328,6.586-3.726,1.105-.683,2.16-1.441,3.22-2.193,1.037-.781,2.066-1.574,3.061-2.41s1.946-1.72,2.9-2.6c.911-.926,1.845-1.827,2.7-2.8a53.485,53.485,0,0,0,4.8-6.107,43.188,43.188,0,0,0,6.417-14.06c-1.956,1.744-3.733,3.519-5.522,5.245s-3.544,3.429-5.306,5.1c-3.519,3.338-7.066,6.544-10.72,9.619-.893.794-1.834,1.53-2.756,2.291l-1.389,1.135c-.47.369-.948.728-1.41,1.111-1.868,1.491-3.866,2.985-5.813,4.642a40.582,40.582,0,0,0-5.533,5.555,18.965,18.965,0,0,0-3.676,6.982",
    transform: "translate(-50.018 -38.393)",
    fill: "#ffd5ab"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Path_368",
    "data-name": "Path 368",
    d: "M267.116,176.346a135.88,135.88,0,0,1-111.172,70.585l.337,4.488a139.4,139.4,0,0,0,65.36-23.375,138.271,138.271,0,0,0,45.475-51.7",
    transform: "translate(-41.555 -46.991)",
    fill: "#ffd5ab"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Path_369",
    "data-name": "Path 369",
    d: "M316.783,125.6c-1.616,3.646-2.851,7.275-4.1,10.883-1.224,3.61-2.395,7.2-3.548,10.8s-2.282,7.206-3.378,10.858c-1.075,3.663-2.17,7.336-2.961,11.246a47.218,47.218,0,0,0,6.644-9.736,66.776,66.776,0,0,0,4.516-10.828,67.487,67.487,0,0,0,2.59-11.442,47.621,47.621,0,0,0,.237-11.784",
    transform: "translate(-80.686 -33.468)",
    fill: "#ffd5ab"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "Path_370",
    "data-name": "Path 370",
    d: "M289.445,135.225a17.5,17.5,0,0,0-4.127,5.168,25.613,25.613,0,0,0-2.349,6.289,38.924,38.924,0,0,0-.588,13.225,86.474,86.474,0,0,0,2.566,12.516c1.106,4.054,2.247,8,3.451,12.2a39.649,39.649,0,0,0,.914-12.913c-.282-4.265-.877-8.4-1.345-12.443a81.5,81.5,0,0,1-.632-11.976,40.811,40.811,0,0,1,2.11-12.065",
    transform: "translate(-75.166 -36.034)",
    fill: "#ffd5ab"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "Path_371",
    "data-name": "Path 371",
    d: "M330.288,162.692a40.826,40.826,0,0,1-8.658,8.664,81.51,81.51,0,0,1-10.163,6.368c-3.574,1.94-7.3,3.833-10.953,6.054a39.67,39.67,0,0,0-10.04,8.172c4.125-1.427,8.012-2.763,11.965-4.189a86.412,86.412,0,0,0,11.716-5.1,38.909,38.909,0,0,0,10.482-8.084,25.626,25.626,0,0,0,3.8-5.539,17.5,17.5,0,0,0,1.856-6.348",
    transform: "translate(-77.403 -43.353)",
    fill: "#ffd5ab"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "Path_372",
    "data-name": "Path 372",
    d: "M272.584,159.155a17.5,17.5,0,0,0-4.494,4.852,25.609,25.609,0,0,0-2.8,6.1,38.935,38.935,0,0,0-1.556,13.146,86.5,86.5,0,0,0,1.642,12.67c.806,4.125,1.656,8.147,2.549,12.419a39.677,39.677,0,0,0,1.857-12.812c.031-4.274-.259-8.444-.429-12.507a81.585,81.585,0,0,1,.246-11.99,40.82,40.82,0,0,1,2.989-11.878",
    transform: "translate(-70.266 -42.41)",
    fill: "#ffd5ab"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "Path_373",
    "data-name": "Path 373",
    d: "M311.089,190.405a40.844,40.844,0,0,1-9.27,8.006,81.594,81.594,0,0,1-10.6,5.606c-3.707,1.673-7.563,3.287-11.368,5.235a39.658,39.658,0,0,0-10.612,7.415c4.218-1.122,8.193-2.169,12.24-3.3a86.416,86.416,0,0,0,12.058-4.224,38.922,38.922,0,0,0,11.046-7.295,25.6,25.6,0,0,0,4.191-5.245,17.515,17.515,0,0,0,2.316-6.2",
    transform: "translate(-71.744 -50.737)",
    fill: "#ffd5ab"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "Path_374",
    "data-name": "Path 374",
    d: "M260.5,183.795a17.5,17.5,0,0,0-5.635,3.463,25.658,25.658,0,0,0-4.342,5.121,38.929,38.929,0,0,0-5.036,12.242,86.453,86.453,0,0,0-1.829,12.645c-.334,4.19-.6,8.291-.888,12.646A39.638,39.638,0,0,0,248,218.073c1.181-4.108,2.024-8.2,2.954-12.161a81.508,81.508,0,0,1,3.464-11.481,40.831,40.831,0,0,1,6.076-10.635",
    transform: "translate(-64.69 -48.976)",
    fill: "#ffd5ab"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "Path_375",
    "data-name": "Path 375",
    d: "M289.931,227.477a40.821,40.821,0,0,1-11.082,5.216,81.566,81.566,0,0,1-11.72,2.545c-4.02.614-8.168,1.131-12.357,1.983a39.659,39.659,0,0,0-12.215,4.285c4.364.056,8.474.117,12.677.114a86.409,86.409,0,0,0,12.75-.823,38.934,38.934,0,0,0,12.6-4.053,25.62,25.62,0,0,0,5.448-3.924,17.5,17.5,0,0,0,3.9-5.343",
    transform: "translate(-64.634 -60.616)",
    fill: "#ffd5ab"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "Path_376",
    "data-name": "Path 376",
    d: "M235.834,200.782a17.5,17.5,0,0,0-5.873,3.041,25.656,25.656,0,0,0-4.706,4.788,38.933,38.933,0,0,0-5.92,11.841,86.405,86.405,0,0,0-2.75,12.477c-.64,4.154-1.2,8.225-1.813,12.547a39.658,39.658,0,0,0,6.09-11.423c1.478-4.011,2.619-8.032,3.836-11.912a81.565,81.565,0,0,1,4.3-11.2,40.831,40.831,0,0,1,6.839-10.162",
    transform: "translate(-57.23 -53.503)",
    fill: "#ffd5ab"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "Path_377",
    "data-name": "Path 377",
    d: "M262.843,247.292a40.808,40.808,0,0,1-11.435,4.389,81.519,81.519,0,0,1-11.874,1.68c-4.054.318-8.229.529-12.469,1.072a39.671,39.671,0,0,0-12.5,3.378c4.348.376,8.443.737,12.634,1.044a86.471,86.471,0,0,0,12.776.112,38.932,38.932,0,0,0,12.865-3.118,25.628,25.628,0,0,0,5.721-3.515,17.508,17.508,0,0,0,4.279-5.043",
    transform: "translate(-57.176 -65.896)",
    fill: "#ffd5ab"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "Path_378",
    "data-name": "Path 378",
    d: "M215.842,211.723a17.487,17.487,0,0,0-6.135,2.472,25.574,25.574,0,0,0-5.138,4.322,38.919,38.919,0,0,0-7.014,11.227,86.5,86.5,0,0,0-3.919,12.16c-1.031,4.075-1.977,8.074-2.991,12.319a39.653,39.653,0,0,0,7.144-10.8c1.851-3.853,3.368-7.748,4.947-11.5a81.5,81.5,0,0,1,5.336-10.74,40.83,40.83,0,0,1,7.77-9.469",
    transform: "translate(-50.801 -56.418)",
    fill: "#ffd5ab"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "Path_379",
    "data-name": "Path 379",
    d: "M239.5,261.516a40.827,40.827,0,0,1-11.8,3.288,81.476,81.476,0,0,1-11.98.549c-4.067-.067-8.242-.252-12.515-.112a39.647,39.647,0,0,0-12.76,2.18c4.293.785,8.335,1.532,12.479,2.234a86.4,86.4,0,0,0,12.708,1.322,38.934,38.934,0,0,0,13.1-1.887,25.607,25.607,0,0,0,6.028-2.958,17.491,17.491,0,0,0,4.737-4.615",
    transform: "translate(-50.749 -69.686)",
    fill: "#ffd5ab"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "Path_380",
    "data-name": "Path 380",
    d: "M195.778,220.389a17.491,17.491,0,0,0-6.341,1.883,25.614,25.614,0,0,0-5.523,3.818,38.927,38.927,0,0,0-8.039,10.516,86.465,86.465,0,0,0-5.047,11.737c-1.41,3.96-2.729,7.852-4.139,11.983a39.645,39.645,0,0,0,8.13-10.075c2.206-3.661,4.083-7.4,6.008-10.978a81.537,81.537,0,0,1,6.324-10.189,40.825,40.825,0,0,1,8.627-8.695",
    transform: "translate(-44.417 -58.727)",
    fill: "#ffd5ab"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: "Path_381",
    "data-name": "Path 381",
    d: "M215.894,273.007a40.839,40.839,0,0,1-12.056,2.162,81.585,81.585,0,0,1-11.979-.582c-4.042-.45-8.182-1.028-12.448-1.292a39.672,39.672,0,0,0-12.909.968c4.2,1.185,8.154,2.311,12.213,3.4a86.437,86.437,0,0,0,12.526,2.513,38.927,38.927,0,0,0,13.222-.644,25.608,25.608,0,0,0,6.28-2.376,17.489,17.489,0,0,0,5.151-4.149",
    transform: "translate(-44.368 -72.748)",
    fill: "#ffd5ab"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    id: "Path_382",
    "data-name": "Path 382",
    d: "M296.8,147.843a16.714,16.714,0,0,0-2.95,7.027,21.9,21.9,0,0,0-.019,7.686c.122.634.253,1.267.417,1.892s.359,1.237.571,1.831a35.255,35.255,0,0,0,1.441,3.4c1.057,2.181,2.143,4.174,3.241,6.51a11.7,11.7,0,0,0,.517-3.825,24.227,24.227,0,0,0-.385-3.755c-.2-1.214-.475-2.381-.712-3.51-.117-.565-.256-1.114-.347-1.667-.122-.546-.219-1.1-.313-1.65-.392-2.206-.671-4.431-.89-6.724s-.324-4.638-.571-7.212",
    transform: "translate(-78.209 -39.396)",
    fill: "#ffd5ab"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "Path_383",
    "data-name": "Path 383",
    d: "M321.629,158.153c-.775,1.08-1.432,2.116-2.144,3.1s-1.391,1.93-2.135,2.821-1.459,1.77-2.238,2.591c-.763.833-1.554,1.63-2.383,2.382-.4.392-.826.756-1.254,1.118s-.86.719-1.3,1.067c-.885.709-1.785,1.338-2.78,2.028a31.277,31.277,0,0,0-3.043,2.288,9.186,9.186,0,0,0-2.424,3.139c2.4-1.054,4.61-1.425,7.048-2.261a15.674,15.674,0,0,0,1.823-.731,16.831,16.831,0,0,0,1.779-.935,9.985,9.985,0,0,0,.845-.544c.275-.191.562-.369.824-.577.529-.413,1.05-.836,1.54-1.292s.946-.948,1.4-1.436c.419-.522.868-1.018,1.238-1.576a18.291,18.291,0,0,0,1.959-3.47,14.928,14.928,0,0,0,1.241-7.71",
    transform: "translate(-80.455 -42.143)",
    fill: "#ffd5ab"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: "Path_384",
    "data-name": "Path 384",
    d: "M167.593,67.991a20.273,20.273,0,0,1,28.226-25.88c3.525,1.9,6.405,4.776,9.622,7.156a7.132,7.132,0,0,1,2.676,2.754,6.234,6.234,0,0,1-.092,3.834,51.308,51.308,0,0,1-4.958,12.417c-.007-.155-.014-.309-.021-.464-.084-1.65-.218-3.118-.407-4.439-.976-6.476-2.465-10.17-4.769-16.3A27.1,27.1,0,0,1,175.277,67.38a3.436,3.436,0,0,0-1.524-1.208,3.531,3.531,0,0,0-3.083.288,4.112,4.112,0,0,0-1.749,2.795,5.711,5.711,0,0,0-.07,1.194,18.782,18.782,0,0,1-1.257-2.458",
    transform: "translate(-44.222 -10.584)",
    fill: "#21232b"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    id: "Path_385",
    "data-name": "Path 385",
    d: "M204.189,74.475c0,7.782-3.5,14.5-8.575,17.656-.232.147-.464.288-.7.414a11.146,11.146,0,0,1-1.279.611,12.016,12.016,0,0,1-4.572.913c-5.1,0-9.607-3.273-12.339-8.266a21.662,21.662,0,0,1-1.973-4.98,4.578,4.578,0,0,1-1.931-1.348,11.278,11.278,0,0,1-2.493-4.228,8.216,8.216,0,0,1-.422-2.128,5.712,5.712,0,0,1,.07-1.194,4.115,4.115,0,0,1,1.749-2.795,3.531,3.531,0,0,1,3.083-.288,3.432,3.432,0,0,1,1.524,1.208A27.1,27.1,0,0,0,198.921,49.74c2.3,6.131,3.792,9.825,4.769,16.3.19,1.32.323,2.788.408,4.439.007.155.014.309.021.464.049,1.1.07,2.275.07,3.533",
    transform: "translate(-45.272 -13.254)",
    fill: "#ff9a55"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_230",
    "data-name": "Group 230",
    transform: "translate(147.269 57.174)",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_229",
    "data-name": "Group 229"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_228",
    "data-name": "Group 228",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_386",
    "data-name": "Path 386",
    d: "M200.768,77.944s7.024,8.871,6.307,10.142-5.787.976-5.787.976Z",
    transform: "translate(-200.768 -77.944)",
    fill: "#21232b"
  }))))), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    id: "Path_387",
    "data-name": "Path 387",
    d: "M178.056,100.387l.295-1.482c2.732,4.993,7.241,8.266,12.34,8.266a12.008,12.008,0,0,0,4.572-.913,11.189,11.189,0,0,0,1.278-.611l1.285,6.553.513,2.613L193,124.448l-16.989-13.927.78-3.87Z",
    transform: "translate(-46.902 -26.355)",
    fill: "#ff9a55"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    id: "Path_388",
    "data-name": "Path 388",
    d: "M172.923,93.319l-.295,1.482a10.154,10.154,0,0,1-14.06-14.643c1.629-1.636,4.087-2.71,6.278-1.981a18.87,18.87,0,0,0,1.257,2.458,8.205,8.205,0,0,0,.422,2.128,11.266,11.266,0,0,0,2.493,4.228,4.586,4.586,0,0,0,1.931,1.349,21.671,21.671,0,0,0,1.973,4.979",
    transform: "translate(-41.475 -20.77)",
    fill: "#21232b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_233",
    "data-name": "Group 233",
    transform: "translate(133.716 61.607)",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_232",
    "data-name": "Group 232"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_231",
    "data-name": "Group 231",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_389",
    "data-name": "Path 389",
    d: "M189.11,87.656A3.414,3.414,0,1,1,185.96,84a3.415,3.415,0,0,1,3.15,3.66",
    transform: "translate(-182.291 -83.987)",
    fill: "#21232b"
  }))))), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    id: "Path_390",
    "data-name": "Path 390",
    d: "M207.654,68.479a12.594,12.594,0,0,1,4.876,1.468c1.781.969.193,3.689-1.59,2.719a8.662,8.662,0,0,0-3.286-1.038,1.618,1.618,0,0,1-1.575-1.574,1.586,1.586,0,0,1,1.575-1.575",
    transform: "translate(-54.914 -18.246)",
    fill: "#21232b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_236",
    "data-name": "Group 236",
    transform: "translate(151.446 54.089)",
    opacity: 0.3,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_235",
    "data-name": "Group 235"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_234",
    "data-name": "Group 234",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_391",
    "data-name": "Path 391",
    d: "M206.462,76.785a2.661,2.661,0,1,0,2.633-3.047,2.863,2.863,0,0,0-2.633,3.047",
    transform: "translate(-206.462 -73.738)",
    fill: "#21232b"
  }))))), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    id: "Path_392",
    "data-name": "Path 392",
    d: "M207.4,78.393a1.973,1.973,0,1,0,1.942-2.324,2.158,2.158,0,0,0-1.942,2.324",
    transform: "translate(-55.267 -20.27)",
    fill: "#21232b"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    id: "Path_393",
    "data-name": "Path 393",
    d: "M192.214,68.14a12.594,12.594,0,0,0-4.876,1.468c-1.781.969-.193,3.689,1.59,2.719a8.662,8.662,0,0,1,3.286-1.038,1.618,1.618,0,0,0,1.575-1.574,1.586,1.586,0,0,0-1.575-1.575",
    transform: "translate(-49.712 -18.156)",
    fill: "#21232b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_239",
    "data-name": "Group 239",
    transform: "translate(138.531 53.84)",
    opacity: 0.3,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Group_238",
    "data-name": "Group 238"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_237",
    "data-name": "Group 237",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_394",
    "data-name": "Path 394",
    d: "M194.12,76.445a2.661,2.661,0,1,1-2.633-3.047,2.863,2.863,0,0,1,2.633,3.047",
    transform: "translate(-188.855 -73.398)",
    fill: "#21232b"
  }))))), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    id: "Path_395",
    "data-name": "Path 395",
    d: "M193.68,78.054a1.973,1.973,0,1,1-1.942-2.324,2.158,2.158,0,0,1,1.942,2.324",
    transform: "translate(-50.575 -20.18)",
    fill: "#21232b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_242",
    "data-name": "Group 242",
    transform: "translate(140.764 67.438)",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Group_241",
    "data-name": "Group 241"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_240",
    "data-name": "Group 240",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_396",
    "data-name": "Path 396",
    d: "M192.395,94.153c-.924,1.81-.519,3.865.9,4.592s3.326-.15,4.25-1.96.519-3.865-.9-4.592-3.326.15-4.25,1.96",
    transform: "translate(-191.899 -91.937)",
    fill: "#21232b"
  }))))), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    id: "Path_397",
    "data-name": "Path 397",
    d: "M192.284,93.139a3.665,3.665,0,1,0,6.562,3.267c.9-1.812-.879-1.917-2.691-2.819s-2.969-2.26-3.872-.448",
    transform: "translate(-51.135 -24.581)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_245",
    "data-name": "Group 245",
    transform: "translate(130.988 72.549)",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Group_244",
    "data-name": "Group 244"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_243",
    "data-name": "Group 243",
    clipPath: "url(#clip-path-15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_398",
    "data-name": "Path 398",
    d: "M180.322,104.588a21.569,21.569,0,0,0,18.533,9.382l-.347-1.771-1.286-6.553a11.445,11.445,0,0,1-1.278.611,12.021,12.021,0,0,1-4.572.912c-5.1,0-9.608-3.273-12.34-8.266l-.295,1.482-.165.821a17.434,17.434,0,0,0,1.75,3.382",
    transform: "translate(-178.572 -98.904)",
    fill: "#21232b"
  }))))), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    id: "Path_399",
    "data-name": "Path 399",
    d: "M205.98,129.086c3.259,4.488,6.9,32.932,6.9,32.932a35.133,35.133,0,0,1-7.424,1.3L198.3,183.1l3.294,7.915v.007a5.559,5.559,0,0,0-2.058,2.036l-34.364-12.887-.414-9.98v-.007c1.152-.21,2.339-.456,3.575-.751l1.917-15.557c-12.367,3.462-28.317.274-28.317.274.625-8.406,1.559-18.211,2.739-22.727,2.283-8.716,19.447-15.114,19.447-15.114a13.825,13.825,0,0,0,.077,2.95c.913,7.515,8.4,18.836,13.471,19s6.25-9.172,6.25-9.172,2.438,6.476,7.487,6.637c3.961.126,4.136-10.24.815-15.76.323.14,10.555,4.7,13.758,9.123",
    transform: "translate(-37.822 -30.993)",
    fill: "#2c3344"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    id: "Path_400",
    "data-name": "Path 400",
    d: "M207.473,120.155c3.322,5.521,3.146,15.887-.815,15.76-5.05-.161-7.486-6.637-7.486-6.637l5.338-9.636L204,117.029a6.753,6.753,0,0,1,3.469,3.118Z",
    transform: "translate(-53.074 -31.185)",
    fill: "#fff"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    id: "Path_401",
    "data-name": "Path 401",
    d: "M174.974,113.335l16.989,13.927s-1.173,9.341-6.251,9.173-12.557-11.483-13.47-19a13.8,13.8,0,0,1-.078-2.95c.408-4.7,3.589-5.022,3.589-5.022Z",
    transform: "translate(-45.864 -29.169)",
    fill: "#fff"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    id: "Path_402",
    "data-name": "Path 402",
    d: "M169.924,167.525l-1.917,15.557c-1.236.295-2.423.541-3.574.751-8.934,1.65-15.318.941-19.194.007a18.514,18.514,0,0,1-4.538-1.6s.324-6.616.907-14.44c0,0,15.949,3.189,28.317-.274",
    transform: "translate(-37.492 -44.641)",
    fill: "#fff"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    id: "Path_403",
    "data-name": "Path 403",
    d: "M181.226,152.934,178.379,173.2l-.8,5.717c-.062.442.615.633.677.186q1.425-10.134,2.848-20.267l.8-5.716c.062-.442-.614-.634-.677-.187",
    transform: "translate(-47.318 -40.684)",
    fill: "#21232b"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    id: "Path_404",
    "data-name": "Path 404",
    d: "M227.591,158.9a27,27,0,0,0-3.938-10.751c-1.162-1.923-2.462-3.757-3.763-5.588-.26-.365-.869-.015-.607.354a52.62,52.62,0,0,1,5.965,9.835,23.1,23.1,0,0,1,.18,17.479c-.166.42.513.6.678.187a23.821,23.821,0,0,0,1.485-11.516",
    transform: "translate(-58.415 -37.948)",
    fill: "#21232b"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    id: "Path_405",
    "data-name": "Path 405",
    d: "M204.611,315.32H129.055c-.478-23.984,1.089-42.223,3.42-55.918,4.882-28.648,13.127-37.427,13.127-37.427a25.276,25.276,0,0,0,2.872.913s-.358,1.411-.864,3.849c-3.2,15.444-12.262,72.051,27.033,72.051a34.736,34.736,0,0,0,9.636-1.257h.007c9.165-2.634,14.461-9.165,17.333-17.214.3-.836.576-1.693.822-2.564l.049.885Z",
    transform: "translate(-34.366 -59.15)",
    fill: "#2c3344"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    id: "Path_406",
    "data-name": "Path 406",
    d: "M205.973,229.19c.674,2.486,7.7,29.224,2.071,48.9-3.371,11.785-11.279,21.034-27.8,21.034-45.5,0-26.169-75.9-26.169-75.9,12.895,3.455,47.027,6.721,47.027,6.721s1.953-.231,4.867-.751",
    transform: "translate(-39.971 -59.482)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_248",
    "data-name": "Group 248",
    transform: "translate(98.109 162.825)",
    opacity: 0.5,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Group_247",
    "data-name": "Group 247"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_246",
    "data-name": "Group 246",
    clipPath: "url(#clip-path-16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_407",
    "data-name": "Path 407",
    d: "M175.917,298.788a34.707,34.707,0,0,0,9.636-1.257,36.5,36.5,0,0,1-12.929,3.659,30.17,30.17,0,0,1-13.407-1.8,31.17,31.17,0,0,1-11.35-7.866,47.536,47.536,0,0,1-7.893-11.736,68.218,68.218,0,0,1-5.2-14.9q-.622-2.718-1.018-5.478c4.881-28.647,13.126-37.426,13.126-37.426a25.078,25.078,0,0,0,2.872.912s-.358,1.412-.863,3.849c-3.2,15.444-12.262,72.051,27.032,72.051",
    transform: "translate(-133.749 -221.975)",
    fill: "#2c3344"
  }))))), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    id: "Path_408",
    "data-name": "Path 408",
    d: "M228.882,298.9c-.281.569-.569,1.124-.871,1.678.3-.836.576-1.692.822-2.563Z",
    transform: "translate(-60.758 -79.413)",
    fill: "#21232b"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    id: "Path_409",
    "data-name": "Path 409",
    d: "M254.338,212.173H198.059a6.176,6.176,0,0,1-6.158-6.157v-3.64a6.176,6.176,0,0,1,6.158-6.158h56.279a6.176,6.176,0,0,1,6.157,6.158v3.64a6.175,6.175,0,0,1-6.157,6.157",
    transform: "translate(-51.136 -52.286)",
    fill: "#fff"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    id: "Path_410",
    "data-name": "Path 410",
    d: "M269.4,190.421H213.117a6.176,6.176,0,0,1-6.158-6.157v-3.641a6.176,6.176,0,0,1,6.158-6.158H269.4a6.176,6.176,0,0,1,6.157,6.158v3.641a6.176,6.176,0,0,1-6.157,6.157",
    transform: "translate(-55.149 -46.49)",
    fill: "#c5dddc"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    id: "Path_411",
    "data-name": "Path 411",
    d: "M257.528,168.635H201.249a6.176,6.176,0,0,1-6.158-6.157v-3.641a6.176,6.176,0,0,1,6.158-6.158h56.279a6.176,6.176,0,0,1,6.157,6.158v3.641a6.176,6.176,0,0,1-6.157,6.157",
    transform: "translate(-51.986 -40.685)",
    fill: "#fff"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    id: "Path_412",
    "data-name": "Path 412",
    d: "M277.695,160.695a6.226,6.226,0,0,0-4.676-2.449c-1.705-.1-3.938.5-4.838,2.093a2.132,2.132,0,0,0,.521,2.7,4.687,4.687,0,0,0,3.354.818c.9-.028,2.14-.089,2.561-1.05a1.238,1.238,0,0,0-.863-1.8c-.447-.059-.442.643,0,.7.268.036.31.437.274.643a.945.945,0,0,1-.756.667,4.59,4.59,0,0,1-1.136.129,8.614,8.614,0,0,1-1.568-.043,2.2,2.2,0,0,1-1.943-1.449c-.194-.868.563-1.581,1.236-1.983a5.638,5.638,0,0,1,4.273-.549,4.891,4.891,0,0,1,3.5,2.972c.533,1.7-.893,3.029-2.27,3.732a9.966,9.966,0,0,1-5.3,1.012c-2.9-.234-7.028-2.273-6.239-5.826a5.742,5.742,0,0,1,3.483-3.83,16.376,16.376,0,0,1,6.311-.839.351.351,0,0,0,0-.7,16.618,16.618,0,0,0-6.766.977,6.375,6.375,0,0,0-3.7,4.208,4.889,4.889,0,0,0,1.9,4.839,9.287,9.287,0,0,0,5.7,1.908,9.836,9.836,0,0,0,6.055-1.823,4.122,4.122,0,0,0,1.57-2.193,3.5,3.5,0,0,0-.675-2.867",
    transform: "translate(-70.094 -41.475)",
    fill: "#c5dddc"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    id: "Path_413",
    "data-name": "Path 413",
    d: "M275.672,204.1A6.226,6.226,0,0,0,271,201.65c-1.705-.1-3.938.5-4.838,2.093a2.132,2.132,0,0,0,.521,2.7,4.687,4.687,0,0,0,3.354.818c.9-.028,2.14-.089,2.561-1.05a1.238,1.238,0,0,0-.863-1.8c-.447-.059-.442.643,0,.7.268.036.31.437.274.643a.945.945,0,0,1-.756.667,4.59,4.59,0,0,1-1.136.129,8.615,8.615,0,0,1-1.568-.043,2.2,2.2,0,0,1-1.943-1.449c-.194-.868.563-1.581,1.236-1.983a5.638,5.638,0,0,1,4.273-.549,4.891,4.891,0,0,1,3.5,2.972c.533,1.7-.893,3.029-2.27,3.733a9.966,9.966,0,0,1-5.3,1.012c-2.9-.234-7.028-2.273-6.239-5.826a5.742,5.742,0,0,1,3.483-3.83,16.376,16.376,0,0,1,6.311-.839.351.351,0,0,0,0-.7,16.618,16.618,0,0,0-6.766.977,6.375,6.375,0,0,0-3.7,4.208,4.889,4.889,0,0,0,1.9,4.839,9.286,9.286,0,0,0,5.7,1.908,9.836,9.836,0,0,0,6.055-1.823,4.122,4.122,0,0,0,1.57-2.193,3.5,3.5,0,0,0-.675-2.867",
    transform: "translate(-69.555 -53.041)",
    fill: "#c5dddc"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    id: "Path_414",
    "data-name": "Path 414",
    d: "M224.7,182.257a6.226,6.226,0,0,0-4.676-2.449c-1.705-.1-3.938.5-4.838,2.093a2.132,2.132,0,0,0,.521,2.7,4.687,4.687,0,0,0,3.354.818c.9-.028,2.14-.089,2.561-1.05a1.238,1.238,0,0,0-.863-1.8c-.447-.059-.442.643,0,.7.268.036.31.437.274.643a.945.945,0,0,1-.756.667,4.591,4.591,0,0,1-1.136.129,8.615,8.615,0,0,1-1.568-.043,2.2,2.2,0,0,1-1.943-1.449c-.194-.868.563-1.581,1.236-1.983a5.638,5.638,0,0,1,4.273-.549,4.891,4.891,0,0,1,3.5,2.972c.533,1.7-.893,3.029-2.27,3.733a9.966,9.966,0,0,1-5.3,1.012c-2.9-.234-7.028-2.273-6.239-5.826a5.742,5.742,0,0,1,3.483-3.83,16.376,16.376,0,0,1,6.311-.839.351.351,0,0,0,0-.7,16.617,16.617,0,0,0-6.766.977,6.375,6.375,0,0,0-3.7,4.208,4.889,4.889,0,0,0,1.9,4.839,9.287,9.287,0,0,0,5.7,1.908,9.835,9.835,0,0,0,6.055-1.823,4.122,4.122,0,0,0,1.57-2.193,3.5,3.5,0,0,0-.675-2.867",
    transform: "translate(-55.972 -47.221)",
    fill: "#fff"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    id: "Path_415",
    "data-name": "Path 415",
    d: "M205.118,220.273c-2.914.52-4.867.751-4.867.751s-34.133-3.266-47.027-6.721a25.286,25.286,0,0,1-2.872-.913,3.807,3.807,0,0,1-1.91-1.215c-2.143-4.1-1.581-22.412-1.581-22.412,3.877.934,10.261,1.644,19.195-.007v.007l.414,9.98,34.365,12.887a5.556,5.556,0,0,1,2.058-2.037v-.007c3.209-1.9,8.028-1.279,8.028-1.279s7.353-8.427,7.943-6.244-3.258,7.283-3.258,7.283h13.927c-4.122,5.612-17.214,8.645-24.413,9.924",
    transform: "translate(-39.116 -50.565)",
    fill: "#ff9a55"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    id: "Path_416",
    "data-name": "Path 416",
    d: "M154.951,154.895q-.028,4.49-.054,8.981a.351.351,0,0,0,.7,0q.026-4.49.054-8.981a.351.351,0,0,0-.7,0",
    transform: "translate(-41.276 -41.185)",
    fill: "#21232b"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.9dedff54f326d06f5448048a26ec0ae4.svg";
export { ForwardRef as ReactComponent };